import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';

export enum JobRequirementType {
    Checkbox = 0,
    Text = 1
}

export interface JobComplianceRequirement {
    name: string;
    value: string;
    type: JobRequirementType;
}

export interface JobComplianceRequirementChange {
    name: string;
    originalValue: string;
    newValue: string;
    isDiscrepant: boolean;
}

export interface JobComplianceRequirementChanges {
    newJobId: number;
    changedDate: string | Date;
    originalStatus: string;
    requirementChanges?: JobComplianceRequirementChange[];
}

export interface JobsRequirementsImportResult {
    imported: boolean;
    isValid: boolean;
    preExistingFound: boolean;
    message?: string;
    validJobs: number[];
    invalidJobs: number[];
    missingJobs: number[];
    duplicateJobs: number[];
    requirements?: { [jobid: number]: JobComplianceRequirement[] };
}

/**
 * @deprecated Do not use this service.  Use service(s) from "src/app/compliance/api" or "src/app/compliance/api/migration"
 */
@Injectable({ providedIn: 'root' })
export class JobRequirementsService {
    private readonly coreApiPath: string;

    constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova/compliance/job-requirements');
    }

    // ** JobRequirementsController.Import
    importJobRequirements(
        facilityId: number,
        validateOnly: boolean,
        data: FormData
    ): Observable<JobsRequirementsImportResult> {
        return this.http.post<JobsRequirementsImportResult>(
            `${this.coreApiPath}/${facilityId}/import?validateOnly=${validateOnly}`,
            data
        );
    }

    // ** JobRequirementsController.Get
    getJobRequirements(jobId: number): Observable<JobComplianceRequirement[]> {
        return this.http.get<JobComplianceRequirement[]>(`${this.coreApiPath}/${jobId}`);
    }

    // ** JobRequirementsController.GetJobRequirementChanges
    getJobRequirementsChanges(jobId: number, contractId: number): Observable<JobComplianceRequirementChanges> {
        return this.http.get<JobComplianceRequirementChanges>(
            `${this.coreApiPath}/${jobId}/contract-exceptions/${contractId}`
        );
    }
}
